import { postRequest } from "./request";

export function UserCertificates(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `get-user-certificates`,
    token: userData.token,
  }).then((response) => {
    return response ? response : undefined;
  });
}
